<div class="header">
  <div class="title">{{ $title() }}</div>
  @if ($context().length > 0) {
    <div class="subtitle">
      @for (item of $context(); track item.label; let last = $last) {
        <span>{{ item.label }}</span>
        @if (item.detail) {
          <span class="subtitle-dot">&middot;</span>
          <span>{{ item.detail }}</span>
        }
        @if (!last) {
          <span class="subtitle-dot">&middot;</span>
        }
      }
    </div>
  }
</div>

@if ($reasoning()) {
  <div class="reasoning">{{ $reasoning() }}</div>
}

@if ($fields().length > 0) {
  <div class="fields">
    @for (field of $fields(); track field.key) {
      <div class="field">
        @if (field.previousValue !== undefined) {
          <div class="field-diff">
            <span class="field-diff-old">{{ field.previousValue || '(empty)' }}</span>
            <span class="field-diff-arrow">→</span>
            <span class="field-diff-new">{{ field.value }}</span>
          </div>
        } @else {
          <div class="field-label">{{ field.label }}</div>
          @if (field.isLong) {
            <div class="field-value field-value--long">{{ field.value }}</div>
          } @else {
            <div class="field-value">{{ field.value }}</div>
          }
        }
      </div>
    }
  </div>
}

<div class="footer">
  <wb-button [label]="'Decline'" [displayStyle]="ButtonDisplayStyle.Tertiary" [disabled]="$disabled()" (onClick)="onDecline()" />
  <wb-button [label]="'Approve'" [iconRight]="'fa-regular fa-arrow-turn-down-left'" [displayStyle]="ButtonDisplayStyle.Secondary" [disabled]="$disabled()" (onClick)="onApprove()" />
</div>
